// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Ta7j","backBtn":"styles_backBtn__3zAtX"};